import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from './client';

/**
 * Hook to delete an invoice via DELETE /api/v2/invoices/{public_token}/
 */
export function useDeleteInvoice() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: async (publicToken: string) => {
      await api.delete(`/v2/invoices/${publicToken}/`);
    },
    onSuccess: (_, publicToken) => {
      queryClient.removeQueries({ queryKey: ['invoice', publicToken] });
      queryClient.invalidateQueries({ queryKey: ['invoices'] });
    },
  });
}
